/**
 * Feature flags. Plain constants for now: Kwento launches in one market, so a
 * flag service would be machinery without a reason. They are read through this
 * module so that turning one on is one visible edit in review.
 */
export interface Flags {
  /**
   * Spanish (es.json) stays in the code but is not shipped.
   *
   * DO NOT ENABLE BEFORE LEGAL REVIEW OF THE SPANISH TEXTS.
   *
   * The Spanish retention and deletion copy is legal text that was written by a
   * model and has been read by nobody. Launch is Philippines, English only
   * (CLAUDE.md, "Launch scope"). The i18n parity test keeps es.json in step with
   * en.json, which says the keys match, not that the sentences are right.
   */
  spanish: boolean
}

export const FLAGS: Flags = {
  spanish: false,
}
